import React from "react";
import {ApiResponse} from './axios';
import {FormattedMessage} from 'react-intl';

export const enum DepartmentType {
    "NONE" = "none",
    "TECHNICAL" = "technical",
    "SUPPORT" = "support",
    "CONTENT" = "content",
    "MANAGEMENT" = "management"
}
export const enum TicketStatus {
    "NONE" = "none",
    "PENDING" = "pending",
    "INPROGRESS" = "in_progress",
    "CLOSE" = "close"
}
export interface Ticket extends ApiResponse {
    admin_user: any;
    id: string;
    department: DepartmentType;
    status: TicketStatus,
    title:string;
    body: string;
    response:string;
    user: any;
    created_at: any;
    modified_at: any;
    close_time:string;
    user_ip:string;
}

export interface TicketState {
    readonly loading: boolean
    readonly data: Ticket[]
    readonly errors?: string
    readonly count: number
    readonly pendingTickets:number
}

export const DepartmentTypeOptions = [{
    value: DepartmentType.NONE,
    label: <FormattedMessage id="app.none" defaultMessage={`None`}/>
}, {
    value: DepartmentType.TECHNICAL,
    label: <FormattedMessage id="app.technical" defaultMessage={`Technical`}/>
}, {
    value: DepartmentType.SUPPORT,
    label: <FormattedMessage id="app.support" defaultMessage={`Support`}/>
}, {
    value: DepartmentType.CONTENT,
    label: <FormattedMessage id="app.content" defaultMessage={`Content`}/>
}, {
    value: DepartmentType.MANAGEMENT,
    label: <FormattedMessage id="app.management" defaultMessage={`Management`}/>
}];

export const StatusTypeOptions = [{
    value: TicketStatus.NONE,
    label: <FormattedMessage id="app.none" defaultMessage={`None`}/>
}, {
    value: TicketStatus.PENDING,
    label: <FormattedMessage id="app.pending" defaultMessage={`Pending`}/>,
    color : 'blue'
}, {
    value: TicketStatus.INPROGRESS,
    label: <FormattedMessage id="app.in_progress" defaultMessage={`In Progress`}/>,
    color : 'green'
}, {
    value: TicketStatus.CLOSE,
    label: <FormattedMessage id="app.close" defaultMessage={`Close`}/>,
    color : 'red'
}];
